/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { Theme } from '@mui/material/styles';
import { useSearchParams } from 'react-router-dom';
import Link from '@mui/material/Link';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import OhsDocumentFilterModels from 'documents/register/search/OhsDocumentFilterModels';
import useOhsDocumentList from 'documents/hook/useOhsDocumentList';

const useStyles = makeStyles()((theme: Theme) => ({
  link: {
    display: 'flex',
    fontSize: 'small',
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
}));

function OhsBreadcrumbDocumentsFolderView() {
  const { classes } = useStyles();

  const [searchParams] = useSearchParams();
  const { folderView, category, subcategory } = new OhsDocumentFilterModels({ searchParams });
  const { changeFolderView, changeCategory } = useOhsDocumentList();

  if (!folderView) return <span />;

  const returnFolderViewLink = () => {
    if (!folderView) return '';

    if (!category) return <Typography className={classes.link}>Folders</Typography>;

    return (
      <Link component="button" onClick={() => changeFolderView(true)} className={classes.link}>
        Folders
      </Link>
    );
  };

  const returnCategoryLink = () => {
    if (!folderView || !category) return '';

    if (!subcategory) return <Typography className={classes.link}>{category}</Typography>;

    return (
      <Link component="button" onClick={() => changeCategory(category)} className={classes.link}>
        {category}
      </Link>
    );
  };

  const returnSubcategory = () => {
    if (!folderView || !category || !subcategory) return '';
    return <Typography className={classes.link}>{subcategory}</Typography>;
  };

  return (
    <Breadcrumbs separator={<NavigateNextIcon />} aria-label="breadcrumb">
      {returnFolderViewLink()}
      {returnCategoryLink()}
      {returnSubcategory()}
    </Breadcrumbs>
  );
}

export default OhsBreadcrumbDocumentsFolderView;
